import { RoutablePage, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { verifyEmailCoreX } from '../../../sdk/sign-up-sdk.js';
import { IS_ACCOUNT_VERIFIED } from '../sign-up.constants.js';

/**
 * Component to verify the users email, accepts
 * a validation token.
 */
var VerifyEmailComponent = /** @class */ (function (_super) {
    __extends(VerifyEmailComponent, _super);
    function VerifyEmailComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerifyEmailComponent.prototype.validateEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.canValidateEmail) {
                    return [2 /*return*/];
                }
                this.performValidateEmail();
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(VerifyEmailComponent.prototype, "canValidateEmail", {
        get: function () {
            return this.verificationCode && this.userId;
        },
        enumerable: false,
        configurable: true
    });
    VerifyEmailComponent.prototype.performValidateEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, verifyEmailCoreX(this.userId, this.verificationCode)];
                    case 1:
                        _a.sent();
                        localStorage.setItem(IS_ACCOUNT_VERIFIED, '1');
                        this.finishValidation();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.validateError(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    VerifyEmailComponent.prototype.finishValidation = function () { };
    /**
     * Emits when there was an error trying to
     * validate the users email.
     * @param error Error message from the server
     */
    VerifyEmailComponent.prototype.validateError = function (error) {
        console.error(error);
        this.routeTo({ route: RoutablePage.SIGN_UP_DONE });
        return error;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", Object)
    ], VerifyEmailComponent.prototype, "userId", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", Object)
    ], VerifyEmailComponent.prototype, "verificationCode", void 0);
    __decorate([
        Watch('canValidateEmail', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VerifyEmailComponent.prototype, "validateEmail", null);
    __decorate([
        Emit('verified'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VerifyEmailComponent.prototype, "finishValidation", null);
    __decorate([
        Emit('verification-error'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], VerifyEmailComponent.prototype, "validateError", null);
    VerifyEmailComponent = __decorate([
        Component({
            name: 'corex-verify-email',
        })
    ], VerifyEmailComponent);
    return VerifyEmailComponent;
}(Mixins(MagicConfigMixin)));

export default VerifyEmailComponent;
